import React from 'react';

interface Props {
  children: React.ReactNode;
  // tslint:disable-next-line no-any
  onClick: (event: any) => void;
}

class FastTap extends React.Component<Props> {
  render() {
    const { onClick, children } = this.props;
    return (
      <div onTouchStart={onClick} {...this.props}>
        {children}
      </div>
    );
  }
}

export default FastTap;
